import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../css/PortInfo.css";
import {
  PortInfoStatus,
  PortInfoError,
  PortInfoUpdatedTime,
  PortInfoLoading,
  fetchAsyncPortInfo,
} from "./PortInfoSlice";

import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const PortInfo: React.FC = () => {
  //storeにアクセス
  //ポート情報
  const portInfoData = useSelector(PortInfoStatus);
  //エラー時メッセージ
  const portInfoErrorMsg = useSelector(PortInfoError);
  //ロード中判定
  const portInfoLoadingJudge = useSelector(PortInfoLoading);
  //データ取得時間
  const portInfoGetTime = useSelector(PortInfoUpdatedTime);
  const dispatch = useDispatch();
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const location = useLocation();
  const { fromPortCreate, port_name, port_state, port_address, max_number } =
    (location.state as {
      fromPortCreate?: boolean;
      port_name?: string;
      port_state?: number;
      port_address?: string;
      max_number?: number;
    }) || {};

  const [isModalOpen, setIsModalOpen] = useState(false);

  // ポート作成後にモーダルを表示
  useEffect(() => {
    if (fromPortCreate) {
      setIsModalOpen(true);
    }
  }, [fromPortCreate]);

  //データ取得
  useEffect(() => {
    //状態が初期値だったらAPIリクエスト
    if (portInfoData === null) {
      dispatch(fetchAsyncPortInfo());
    }
  }, [dispatch]);

  useEffect(() => {
    if (shouldUpdate) {
      // ポート作成が成功したら再取得
      dispatch(fetchAsyncPortInfo());
      setShouldUpdate(false);
    }
  }, [shouldUpdate]);

  useEffect(() => {
    dispatch(fetchAsyncPortInfo());
  }, [dispatch]);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="p-port-info">
      <div className="p-port-info__container">
        <h1 className="p-port-info__title">ポート情報一覧</h1>
        <div className="u-text-center">
          <Link to="/Port_create" className="p-port-info__button">
            →ポート新規作成
          </Link>
        </div>
        <div className="u-time">最終更新時間 : {portInfoGetTime}</div>
        <Link to="/Segway_Info" className="u-pc__none p-port-info__segway-button">
          キックボード一覧へ
        </Link>
        <table className="p-port-info__table">
          <thead>
            <tr key="port_title" className="u-text-center">
              <td className="p-port-info__item">ポートID</td>
              <td className="p-port-info__item">ポートステータス</td>
              <td className="p-port-info__item">ポート名</td>
              <td className="p-port-info__item">住所</td>
              <td className="p-port-info__item">駐車可能台数</td>
              <td className="p-port-info__item">駐車台数</td>
            </tr>
          </thead>
          <tbody>
            {portInfoData !== null &&
              portInfoData.map((item) => (
                <tr
                  key={`${item.port_name}${item.port_address}`}
                  className="p-port-info__list u-text-center"
                >
                  <td className="p-port-info__item">{item.port_id}</td>
                  <td className="p-port-info__item">
                    {item.port_state === 1 ? "貸出可能" : item.port_state === 2 ? "返却可能" : item.port_state === 3 ? "貸出・返却可能" : "利用不可"}
                  </td>
                  <td className="p-port-info__item">
                    {item.port_id} {item.port_name}
                  </td>
                  <td className="p-port-info__item">
                    {item.port_address}
                  </td>
                  <td className="p-port-info__item">
                    {item.max_number}
                  </td>
                  <td className="p-port-info__item">
                    {item.now_number}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {isModalOpen && (
        <div className="u-modal">
          <div className="u-modal__inner">
            <button className="u-modal__close" onClick={handleModalClose}>
              &times;
            </button>
            <div className="u-modal__body">
              <h2>ポートを追加しました</h2>
              <p className="u-modal__body__item">ポート名: {port_name}</p>
              <p className="u-modal__body__item">住所: {port_address}</p>
              <p className="u-modal__body__item">駐車可能台数: {max_number}</p>
              <p className="u-modal__body__item">ポートステータス: {port_state === 1 ? "貸出可能" : port_state === 2 ? "返却可能" : port_state === 3 ? "貸出・返却可能" : "利用不可"}</p>
            </div>
            <button onClick={handleModalClose}>閉じる</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortInfo;